export default "__VITE_ASSET__Ce67Kntp__"